import { Component, OnInit } from '@angular/core';
import {NotificationsService} from "../../common/service/notifications.service";
import {UtilitiesService} from "../../common/service/utilities.service";
import {CinchDataService} from "../../common/service/cinch-data.service";
import {
    ApiAddress, ApiContractDataModel, ApiContractOption,
    ApiCoverageItems
} from "../../common/model/cchsApiContractData.model";
import {ContractOption, CoverageDetails} from "../../common/model/cinchAppViewData.model";


@Component({
  selector: 'app-coverage-details',
  templateUrl: './coverage-details.component.html',
  styleUrls: ['./coverage-details.component.scss']
})
export class CoverageDetailsComponent implements OnInit {

  contract: ApiContractDataModel;
  coverageDetails: CoverageDetails;


  constructor(private util:UtilitiesService,
              private cinchData: CinchDataService,
              private notificationMsg: NotificationsService) { }

  ngOnInit() {
      this.cinchData.contractData$.subscribe(contract => {
        if ((contract) && (contract != {}) && (contract.baseContract)){
            this.contract = contract;
            this.coverageDetails = this.cinchData.getCoverageDetailsViewOnFormat(contract);
        }
      } , e => console.log());
  }

  goto( route ){
    this.util.goTo(route);
  }


}
